import React, { useState } from 'react';
import { FiBriefcase, FiFileText, FiMapPin, FiCalendar, FiPlusCircle, FiLayers } from 'react-icons/fi';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import api from '../../api/config';
import './ilanform.css';

const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['clean']
    ]
};

const YurtIlanForm = () => {
    const [kategori, setKategori] = useState('yurt_personel');
    const [ilanData, setIlanData] = useState({
        job_id: Math.floor(100000 + Math.random() * 900000).toString(),
        ilan_basligi: '',
        firma_adi: '',
        ilan_tarihi: new Date().toISOString().split('T')[0],
        is_tipi: 'Tam Zamanlı',
        sehir: '',
        detaylar: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setIlanData({ ...ilanData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const endpoint = kategori === 'yurt_yonetici'
            ? '/api/yurt-yonetici-ilanlar'
            : '/api/yurt-personel-ilanlar';
        try {
            await api.post(endpoint, { ...ilanData, user_id: null });
            alert('İlan başarıyla oluşturuldu!');
            setIlanData({
                job_id: Math.floor(100000 + Math.random() * 900000).toString(),
                ilan_basligi: '',
                firma_adi: '',
                ilan_tarihi: new Date().toISOString().split('T')[0],
                is_tipi: 'Tam Zamanlı',
                sehir: '',
                detaylar: '',
            });
        } catch (error) {
            alert(`Hata: ${error.response?.data?.error || error.message}`);
        }
    };

    return (
        <div className="corp-form-page">
            <div className="corp-form-container">
                <div className="corp-form-header">
                    <h1>Yeni Yurt İlanı Oluştur</h1>
                    <p className="subtitle">Yurt Personel ve Yönetici Kadrosu İçin İlan Yayını</p>
                </div>

                <form onSubmit={handleSubmit} className="corp-actual-form">
                    <div className="corp-id-badge">
                        <FiFileText /> <span>Sistem Tarafından Atanan İlan No: <strong>#{ilanData.job_id}</strong></span>
                    </div>

                    <div className="form-grid-two-col">
                        <div className="corp-form-group">
                            <label htmlFor="kategori"><FiLayers /> İlan Kategorisi</label>
                            <select id="kategori" value={kategori} onChange={(e) => setKategori(e.target.value)} required>
                                <option value="yurt_personel">Yurt Personel</option>
                                <option value="yurt_yonetici">Yurt Yönetici</option>
                            </select>
                        </div>
                        <div className="corp-form-group">
                            <label htmlFor="ilan_basligi"><FiBriefcase /> İlan Başlığı</label>
                            <input type="text" id="ilan_basligi" name="ilan_basligi"
                                placeholder="Örn: Yurt Yönetim Memuru"
                                value={ilanData.ilan_basligi} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="corp-form-group">
                        <label htmlFor="firma_adi"><FiFileText /> Kurum / Yurt Adı</label>
                        <input type="text" id="firma_adi" name="firma_adi"
                            placeholder="Örn: ÖNDER Yükseköğrenim Yurdu"
                            value={ilanData.firma_adi} onChange={handleChange} required />
                    </div>

                    <div className="form-grid-three-col">
                        <div className="corp-form-group">
                            <label htmlFor="ilan_tarihi"><FiCalendar /> Yayın Tarihi</label>
                            <input type="date" id="ilan_tarihi" name="ilan_tarihi"
                                value={ilanData.ilan_tarihi} onChange={handleChange} required />
                        </div>
                        <div className="corp-form-group">
                            <label htmlFor="is_tipi"><FiBriefcase /> Çalışma Tipi</label>
                            <select id="is_tipi" name="is_tipi" value={ilanData.is_tipi} onChange={handleChange} required>
                                <option value="Tam Zamanlı">Tam Zamanlı</option>
                                <option value="Yarı Zamanlı">Yarı Zamanlı</option>
                                <option value="Uzaktan">Uzaktan</option>
                                <option value="Staj">Staj</option>
                            </select>
                        </div>
                        <div className="corp-form-group">
                            <label htmlFor="sehir"><FiMapPin /> Şehir</label>
                            <input type="text" id="sehir" name="sehir"
                                placeholder="Örn: Ankara"
                                value={ilanData.sehir} onChange={handleChange} required />
                        </div>
                    </div>

                    <div className="corp-form-group">
                        <label><FiFileText /> Pozisyon Detayları ve Aranan Kriterler</label>
                        <ReactQuill
                            theme="snow"
                            value={ilanData.detaylar}
                            onChange={(value) => setIlanData({ ...ilanData, detaylar: value })}
                            modules={modules}
                            placeholder="Yurt idari süreçleri, öğrenci ilişkileri yönetimi veya aranan nitelikleri buraya yazınız..."
                        />
                    </div>

                    <button type="submit" className="corp-form-submit-btn">
                        <FiPlusCircle /> İlanı Yayına Al
                    </button>
                </form>
            </div>
        </div>
    );
};

export default YurtIlanForm;